import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/switching/compact/lite-16-poe.png";
import type { Product } from "../../types";
import { productListSwitchingCompact } from "../product-list-groups/productListSwitchingCompact";
import {
  downlinkSpeed,
  etherlighting,
  mounting,
  outdoorReady,
  poeAvailability,
  poeOutput,
  portCount,
  ports,
  powerMethod,
  proAvSupport,
  switchTechnology,
  uplinkSpeed,
} from "../properties";

export const lite16PoE: Product = {
  id: "lite16PoE",
  productTitle: "Lite 16 PoE",
  techspecsPath: [SiteId.TechSpecs, "/unifi/switching/usw-lite-16-poe"],
  storePathParts: {
    productSlug: "usw-lite-16-poe",
    category: "switching-utility",
  },
  sku: "USW-Lite-16-PoE",
  description: "lite16PoE.description",
  descriptionMaxWidth: 150,
  image: { src: image, width: 200, height: 140 },
  productListGroup: productListSwitchingCompact,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '192 x 185 x 44 mm\n(7.6 x 7.3 x 1.7")',
      },
    },
    {
      propertyId: switchTechnology.id,
      value: {
        type: "translation",
        value: "commons.switchingTechnology.layer2",
      },
    },
    {
      propertyId: portCount.id,
      value: { type: "string", value: "16" },
    },
    {
      propertyId: ports.id,
      value: { type: "string", value: "(16) GbE RJ45" },
    },
    {
      propertyId: downlinkSpeed.id,
      value: { type: "string", value: "1 Gbps" },
    },
    {
      propertyId: uplinkSpeed.id,
      value: { type: "string", value: "1 Gbps" },
    },
    {
      propertyId: poeOutput.id,
      value: {
        type: "translation",
        value: "commons.poeOutput.upToPoe+",
      },
    },
    {
      propertyId: poeAvailability.id,
      value: { type: "string", value: "45 W" },
    },
    {
      propertyId: etherlighting.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: proAvSupport.id,
      value: { type: "boolean", value: false },
    },

    {
      propertyId: "generalRedundancy",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: powerMethod.id,
      value: {
        type: "translation",
        value: "commons.powerMethod.acPower",
      },
    },
    {
      propertyId: mounting.id,
      value: {
        type: "translation",
        value: "commons.mounting.desktopWall",
      },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "boolean", value: false },
    },
  ],
};
